const DEFAULT_VIEW_PARAMS = {
    yaw: 0,
    pitch: 0,
    roll: 0,
    fov: Math.PI / 4,
    x: 0.5,
    y: 0.5,
    zoom: 1,
};

const toFiniteNumber = (value, fallback) => {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue : fallback;
};

export const sanitizeViewParams = (params = {}, fallback = {}) => {
    const safeFallback = { ...DEFAULT_VIEW_PARAMS, ...fallback };
    const data = { ...params };

    const x = data.x ?? data.flat_x ?? data.init_view_flat_x;
    const y = data.y ?? data.flat_y ?? data.init_view_flat_y;
    const zoom = data.zoom ?? data.init_view_zoom;

    return {
        yaw: toFiniteNumber(data.yaw, safeFallback.yaw),
        pitch: toFiniteNumber(data.pitch, safeFallback.pitch),
        roll: toFiniteNumber(data.roll, safeFallback.roll),
        fov: toFiniteNumber(data.fov, safeFallback.fov),
        x: toFiniteNumber(x, safeFallback.x),
        y: toFiniteNumber(y, safeFallback.y),
        zoom: Math.max(0.0001, toFiniteNumber(zoom, safeFallback.zoom)),
    };
};

export const sanitizeFlatMediaAspectRatio = (width, height) => {
    const safeWidth = toFiniteNumber(width, 1);
    const safeHeight = toFiniteNumber(height, 1);

    if (safeWidth <= 0 || safeHeight <= 0) {
        return 1;
    }

    return safeWidth / safeHeight;
};
